export default __webpack_public_path__ + "static/media/sampleivr.fe69c7ea.svg";